export enum AppRoutePath {
  callback = '/login/callback',
  home = '/',
}